export const getScheduleEvaluators = (users) => {
  // Preserve name-only demo/legacy entries, but omit explicit null-user placeholders.
  return Array.isArray(users) ? users.filter((user) => {
    return user && user.pk_User !== null &&
      (user.pk_User != null || typeof user.UserFirst === 'string' || typeof user.UserLast === 'string');
  }) : [];
};

export const determineScheduleMessage = (scheduleItem) => {
  const { CustomMeetingTitle, Users, isPassingPeriod, isFlexEvent, EventName } = scheduleItem;
  if (isFlexEvent) return EventName;
  if (isPassingPeriod) return 'Passing Period';

  const users = getScheduleEvaluators(Users);
  if (users.length) {
    const names = users.map((user) => {
      const first = typeof user.UserFirst === 'string' ? user.UserFirst : '';
      const last = typeof user.UserLast === 'string' ? user.UserLast : '';
      if (users.length >= 3) return [first ? `${first[0]}.` : '', last].filter(Boolean).join(' ') || 'Evaluator';
      if (users.length === 2) return [first, last].filter(Boolean).join(' ') || 'Evaluator';
      return [last, first].filter(Boolean).join(', ') || 'Evaluator';
    });
    return names.join(users.length === 2 ? ' & ' : ', ');
  }
  return CustomMeetingTitle || 'Break';
};

const diagnosticText = (value) => {
  return typeof value === 'string' ? value
    .replace(/https?:\/\/\S+/gi, '[url]')
    .replace(/[\w.+-]+@[\w.-]+\.[a-z]{2,}/gi, '[email]')
    .replace(/Bearer\s+\S+/gi, 'Bearer [redacted]') : undefined;
};

export const reportScheduleLoadError = (error) => {
  // Keep the exception and stack useful without logging Axios headers, body or URL.
  try {
    console.error('Candidate schedule load failed', {
      name: diagnosticText(error?.name),
      message: diagnosticText(error?.message),
      stack: diagnosticText(error?.stack),
      status: typeof error?.response?.status === 'number' ? error.response.status : undefined,
    });
  } catch (_) {
    // Diagnostic failures must not interrupt the existing retry/error state.
  }
};
